import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlanogram = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32.001,
	viewBox: "0 0 32 32.001",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(1 1)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(0)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M9,32H5.016a5,5,0,0,1-5-5V5a5.01,5.01,0,0,1,5-5h22a5,5,0,0,1,5,5v9a1,1,0,0,1-2,0V5a3,3,0,0,0-3-3h-22a3.007,3.007,0,0,0-3,3V27a3,3,0,0,0,3,3H9a1,1,0,0,1,0,2Z",
					transform: "translate(-1.018 -1)",
					fill: "current"
				})
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 7,
				height: 4,
				rx: 2,
				transform: "translate(2.982 4)",
				fill: "current"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 7,
				height: 4,
				rx: 2,
				transform: "translate(11.982 4)",
				fill: "current"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 6,
				height: 4,
				rx: 2,
				transform: "translate(20.982 4)",
				fill: "current"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 7,
				height: 4,
				rx: 2,
				transform: "translate(2.982 10)",
				fill: "current"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 7,
				height: 4,
				rx: 2,
				transform: "translate(2.982 16)",
				fill: "current"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 7,
				height: 4,
				rx: 2,
				transform: "translate(11.982 10)",
				fill: "current"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 6,
				height: 4,
				rx: 2,
				transform: "translate(20.982 10)",
				fill: "current"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14,32a1,1,0,0,1-.707-1.707l5-5a1,1,0,0,1,1.539.152l1.286,1.929,8.139-9.044a1,1,0,0,1,1.487,1.338l-9,10a1,1,0,0,1-1.575-.114l-1.323-1.985-4.137,4.137A1,1,0,0,1,14,32Z",
				transform: "translate(-1.018 -1)",
				fill: "current"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M31,27a1,1,0,0,1-1-1V20.011A1.036,1.036,0,0,0,28.989,19H23a1,1,0,0,1,0-2h6.019A3.03,3.03,0,0,1,32,19.981q0,.01,0,.019v6A1,1,0,0,1,31,27Z",
				transform: "translate(-1.018 -1)",
				fill: "current"
			})
		]
	})
});
export { SvgPlanogram as ReactComponent };
